import React from 'react';
import {
  ORDER_PHASE_CONTACTING,
  ORDER_TYPE_DELIVERY,
} from '../../../constants';
import { formatEstimationTime, getEstimationTime } from '../../../utils';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants/date';

type OrderStatusEstimationTimeProps = {
  order: any;
};

export default function OrderStatusEstimationTime({
  order,
}: OrderStatusEstimationTimeProps) {
  const {
    orderType,
    status,
    date,
    datePreparationEnded,
    estimatedDeliveryDate,
  } = order;
  const estimationTime = getEstimationTime(order);
  const { estimationDayFormat } = formatEstimationTime(estimationTime);
  return status === ORDER_PHASE_CONTACTING ? (
    <p className='text-left text-gray mb-2 label'>
      Heure souhaitée :
      <strong>{` ${estimationDayFormat} à ${moment(date).format(DATE_FORMAT.TIME)}`}</strong>
    </p>
  ) : (
    <p className='text-left text-gray mb-2 label'>
      {orderType === ORDER_TYPE_DELIVERY
        ? 'Votre livraison'
        : `L'heure de récupération`}{' '}
      est prévue pour :{' '}
      <strong>{`${estimationDayFormat} à ${moment(estimatedDeliveryDate ?? datePreparationEnded).format(DATE_FORMAT.TIME)}`}</strong>
    </p>
  );
}
